module.exports = __webpack_public_path__ + "static/media/aurivo.44efe370.png";